




















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import BSwitch from "../app/switchs/b-switch.vue";
import SubmitResetButtonGroop from "../buttons/submit-reset-button-groop.vue";
import LanguagesButtons from "../buttons/languages-buttons.vue";

import { IDictionary } from "@/@types/dictionary";
import { ILocale } from "@/@types/locale";
@Component({
  components: { SubmitResetButtonGroop, BSwitch, LanguagesButtons },
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
})
export default class DictionaryForm extends Vue {
  @Prop({ type: Object, default: null }) dictionary!: IDictionary;
  @Prop({ type: String, default: "forms" }) parent!: string;

  locale = this.$store.getters.getLanguages[0];

  name = "";
  names: ILocale = {};

  show = false;

  get contentType(): IDictionary {
    return {
      _id: this.dictionary ? this.dictionary._id : undefined,
      show: this.show,
      name: this.names,
    };
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      console.log("invalid");

      this.$v.$touch();
      return;
    }
    const id = this.dictionary ? this.dictionary._id : undefined;
    this.$emit("updateCT", this.contentType, id);
    this.onReset();
  }

  onReset(): void {
    this.show = false;
    this.name = "";
    this.names = {};
  }

  @Watch("name")
  updateNames(): void {
    this.names[this.locale] = this.name;
  }

  @Watch("locale")
  getDictionaryParams(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";
  }

  @Watch("dictionary", { immediate: true, deep: true })
  loadDictionary(): void {
    if (this.dictionary) {
      this.show = this.dictionary.show;
      this.names = this.dictionary.name ? { ...this.dictionary.name } : {};
      this.getDictionaryParams();
    } else {
      this.onReset();
    }
  }
}
